import get from 'lodash/get'
import find from 'lodash/find'

export default {
  bp: {
    xs: 480,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1441
  }
}



// WEBPACK FOOTER //
// ./src/config.js